import { Component, inject } from "@angular/core";
import { ApiPoll, ApiPollQuestionVote, PollsApi } from "@tytapp/api";
import { CanonicalURLService, OpenGraph, PageComponent } from "@tytapp/common";

@Component({
    templateUrl: './poll-page.component.html',
    styleUrls: ['./poll-page.component.scss']
})
export class PollPageComponent extends PageComponent {
    private pollsApi = inject(PollsApi);
    private opengraph = inject(OpenGraph);
    private canonicalService = inject(CanonicalURLService);

    pollSlug: string;

    get commentIdentifier() {
        return `poll_${this.pollSlug}`;
    }

    poll: ApiPoll;
    userVote: ApiPollQuestionVote;
    voted = false;
    enableComments = false;

    voteChanged(vote: ApiPollQuestionVote) {
        this.userVote = vote;
        this.voted = !!this.userVote;
    }

    get closedEarlier() {
        if (this.poll && this.poll.closes_at) {
            if (new Date(this.poll.closes_at).getTime() < Date.now())
                return true;
        }

        return false;
    }

    init() {
        this.route.paramMap.subscribe(async params => {
            this.enableComments = await this.shell.hasFeature('apps.web.enable_poll_comments');
            this.pageTitle = 'Poll';

            this.pollSlug = params.get('id');

            let poll: ApiPoll;

            try {
                poll = await this.pollsApi.getPoll(this.pollSlug).toPromise();
            } catch (e) {
                if (e.status === 404 || e.error === 'not-found') {
                    this.redirection.go(`/polls`, true);
                    return;
                }

                throw e;
            }

            if (poll.type === 'Petition') {
                this.redirection.go(`/campaigns/${this.pollSlug}`, true);
                return;
            }

            this.poll = poll;
            this.voted = !!this.userVote;

            if (!this.poll) {
                this.router.navigateByUrl('/polls');
                return;
            }

            this.pageTitle = this.poll.title;

            this.opengraph.setMetadata({
                title: this.poll.title,
                image: this.poll.image,
                description: this.poll.description
            });

            if (this.canonicalService.redirectToCanonical(`/polls/${this.poll.slug || this.poll.id}`))
                return;

        });
    }
}